import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class ActivitiesSlider {
	
	constructor(el) {

		this.el = el;

		this.initActivitiesSliderSwipers(el);

	} 

	initActivitiesSliderSwipers(elm){		

		const swiper = new Swiper( elm.querySelector('.swiper'), {    
			modules           : [ Navigation ],
			slidesPerView     : 4,			
			loop              : true,			
			spaceBetween      : 32,
			autoHeight        : false,			
			navigation      : {
				nextEl      : elm.querySelector('.swiper-button-next'),
				prevEl      : elm.querySelector('.swiper-button-prev'),
		  	},
			breakpoints       : {   
			  	10 : {
					slidesPerView   : 1.4,          
					spaceBetween    : 16,
			  	},  
			  	320 : {
					slidesPerView   : 1.4,          
					spaceBetween    : 16,
			  	},     
			  	480 : {
					slidesPerView   : 2.2,          
					spaceBetween    : 20,
			  	},  
			  	640 : {
					slidesPerView   : 3,          
					spaceBetween    : 16,
			  	},    
			  	768 : {
					slidesPerView   : 3,          
					spaceBetween    : 20,
			  	},   
			  	1024 : {
					slidesPerView   : 4,          
					spaceBetween    : 20,
			  	},    
			  	1240 : {
					slidesPerView   : 4,          
					spaceBetween    : 24,
			  	},          
			  	1420 : {
					slidesPerView   : 4,          
					spaceBetween    : 32,
			  	},          
			},
		});

	}

}